import { object, string, boolean } from 'yup';

export default object().shape({
  chave: string().required('Este campo é obrigatório!'),
  valor: string().required('Este campo é obrigatório!'),
  descricao: string().required('Este campo é obrigatório!'),
  unidade: string().nullable(),
  ativo: boolean(),
})

